import { ExecuteMessageActionRequest, MessageAction } from "@accurx/api/apps";
import { httpClient2 } from "@accurx/shared";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

export type ExecuteMessageAction = {
    workspaceId: number;
    messageId: string;
    action: MessageAction;
};

type PassThroughOptions = Omit<
    UseMutationOptions<unknown, Error, ExecuteMessageAction>,
    "mutationFn"
>;
export const useExecuteMessageActionMutation = (options: PassThroughOptions) =>
    useMutation({
        ...options,
        mutationFn: async ({
            workspaceId,
            messageId,
            action,
        }: ExecuteMessageAction) => {
            const request: ExecuteMessageActionRequest = {
                appId: action.appId,
                actionId: action.id,
                messageId,
            };

            await httpClient2.post({
                path: "/api/apps/workspace/:workspaceId/message-actions/execute",
                params: { workspaceId },
                json: request,
            });
        },
    });
